import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-62d65606"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "community-seeking"
};
const _hoisted_2 = {
  class: "community-seeking-title"
};
const _hoisted_3 = {
  class: "community-seeking-tip"
};
const _hoisted_4 = {
  class: "community-seeking-form"
};
const _hoisted_5 = {
  class: "commuinty-seeking-item"
};
const _hoisted_6 = {
  class: "community-item-label"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_8 = {
  key: 0,
  class: "commuinty-seeking-warning"
};
const _hoisted_9 = {
  class: "commuinty-seeking-item"
};
const _hoisted_10 = {
  class: "community-item-label"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_12 = {
  key: 0,
  class: "commuinty-seeking-warning"
};
const _hoisted_13 = {
  class: "commuinty-seeking-item"
};
const _hoisted_14 = {
  class: "community-item-label"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_16 = {
  key: 0,
  class: "commuinty-seeking-warning"
};
const _hoisted_17 = {
  class: "commuinty-seeking-item"
};
const _hoisted_18 = {
  class: "community-item-label"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_20 = {
  key: 0,
  class: "commuinty-seeking-warning"
};
const _hoisted_21 = {
  class: "commuinty-seeking-item"
};
const _hoisted_22 = {
  class: "community-item-label"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "*", -1));
const _hoisted_24 = {
  key: 0,
  class: "commuinty-seeking-warning"
};
const _hoisted_25 = {
  class: "commuinty-seeking-item"
};
const _hoisted_26 = {
  class: "community-item-label"
};
const _hoisted_27 = {
  class: "commuinty-seeking-input"
};
const _hoisted_28 = {
  class: "community-seeking-footer"
};
const _hoisted_29 = {
  key: 0
};
const _hoisted_30 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("seeking_influencers")), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("seeking_tip")), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("label", _hoisted_6, [_createTextVNode(_toDisplayString(_ctx.$t("Name")), 1), _hoisted_7]), _createElementVNode("div", {
    class: _normalizeClass(["commuinty-seeking-input", {
      'community-seeking-input-warning': $data.nameErrMsg
    }])
  }, [_createVNode(_component_el_input, {
    modelValue: $data.name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.name = $event),
    modelModifiers: {
      trim: true
    },
    onFocus: _cache[1] || (_cache[1] = $event => $data.nameErrMsg = ''),
    onBlur: _cache[2] || (_cache[2] = $event => $options.checkRequired('name'))
  }, null, 8, ["modelValue"])], 2), $data.nameErrMsg ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($data.nameErrMsg), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("label", _hoisted_10, [_createTextVNode(_toDisplayString(_ctx.$t("company_name")), 1), _hoisted_11]), _createElementVNode("div", {
    class: _normalizeClass(["commuinty-seeking-input", {
      'community-seeking-input-warning': $data.companyNameErrMsg
    }])
  }, [_createVNode(_component_el_input, {
    modelValue: $data.companyName,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.companyName = $event),
    modelModifiers: {
      trim: true
    },
    onFocus: _cache[4] || (_cache[4] = $event => $data.companyNameErrMsg = ''),
    onBlur: _cache[5] || (_cache[5] = $event => $options.checkRequired('companyName'))
  }, null, 8, ["modelValue"])], 2), $data.companyNameErrMsg ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($data.companyNameErrMsg), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [_createElementVNode("label", _hoisted_14, [_createTextVNode(_toDisplayString(_ctx.$t("email_address")), 1), _hoisted_15]), _createElementVNode("div", {
    class: _normalizeClass(["commuinty-seeking-input", {
      'community-seeking-input-warning': $data.emailErrMsg
    }])
  }, [_createVNode(_component_el_input, {
    modelValue: $data.email,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.email = $event),
    modelModifiers: {
      trim: true
    },
    onFocus: _cache[7] || (_cache[7] = $event => $data.emailErrMsg = ''),
    onBlur: $options.checkEmail
  }, null, 8, ["modelValue", "onBlur"])], 2), $data.emailErrMsg ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($data.emailErrMsg), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("label", _hoisted_18, [_createTextVNode(_toDisplayString(_ctx.$t("estimated_ad")), 1), _hoisted_19]), _createElementVNode("div", {
    class: _normalizeClass(["commuinty-seeking-input", {
      'community-seeking-input-warning': $data.estimatedAdErrMsg
    }])
  }, [_createVNode(_component_el_input, {
    modelValue: $data.estimatedAd,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.estimatedAd = $event),
    modelModifiers: {
      trim: true
    },
    onFocus: _cache[9] || (_cache[9] = $event => $data.estimatedAdErrMsg = ''),
    onBlur: _cache[10] || (_cache[10] = $event => $options.checkRequired('estimatedAd'))
  }, null, 8, ["modelValue"])], 2), $data.estimatedAdErrMsg ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($data.estimatedAdErrMsg), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("label", _hoisted_22, [_createTextVNode(_toDisplayString(_ctx.$t("ad_campaign")), 1), _hoisted_23]), _createElementVNode("div", {
    class: _normalizeClass(["commuinty-seeking-input", {
      'community-seeking-input-warning': $data.adCompaignErrMsg
    }])
  }, [_createVNode(_component_el_select, {
    modelValue: $data.adCompaign,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.adCompaign = $event),
    placeholder: "",
    "popper-class": "commuinty-seeking_select_wrapper"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.adCompaignOptions, item => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: item.value,
        label: _ctx.$t(item.label),
        value: item.value
      }, null, 8, ["label", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])], 2), $data.adCompaignErrMsg ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString($data.adCompaignErrMsg), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [_createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("additional_request")), 1), _createElementVNode("div", _hoisted_27, [_createVNode(_component_el_input, {
    modelValue: $data.addRequest,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.addRequest = $event),
    modelModifiers: {
      trim: true
    },
    maxlength: 5000
  }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", {
    class: "community-seeking-btn",
    onClick: _cache[13] || (_cache[13] = (...args) => $options.handleSubmit && $options.handleSubmit(...args))
  }, _toDisplayString(_ctx.$t("Submit")), 1), $data.showAlert ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["community-seeking-alert", {
      'community-seeking-alert-suc': $data.showAlert == 1,
      'community-seeking-alert-fail': $data.showAlert == 2
    }])
  }, [$data.showAlert == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t("submit_success")) + "😊", 1)) : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t("Failed")), 1))], 2)) : _createCommentVNode("", true)])])]);
}